import React from 'react';
import {v4 as uuidv4} from 'uuid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { t, rest } from '../services';

import toolbarStyles from './ToolBar.styl';
import { LanguageSelector } from '../widgets/LanguageSelector';

import { whoami } from '../users/UserInfo';
import { UserAvatar } from '../users/Avatars';
import { faSignOutAlt } from '@fortawesome/pro-regular-svg-icons';


import '../pages/Form.css';
import '../../css/form.css';
import { WelcomePage } from '../pages/WelcomePage';
import { createBrowserComponent } from '../browsers/Browser';

const displayWelcomePage = () => (gui) => {
  let uuid = uuidv4();
  return { 
      uuid, view: () => <div key={uuid} style={{height: '100%'}}><WelcomePage gui={gui}/></div>
  }
}

export class ToolBar extends createBrowserComponent() {
  constructor(props) {
    super(props)
    this.state = {
        ...this.state,
    }
    this.goTo(displayWelcomePage(), this)
  }

render() {
  return (
    <div style={{ flexGrow: 1, height: '1500px' }}>
      <AppBar position="static">
        <Toolbar color="inherit" className={toolbarStyles.toolbar} >
      		<h3 style={{position: 'absolute', cursor: 'pointer'}} onClick={() => this.goTo(displayWelcomePage(), this)}>{t`Home`}</h3>
            <div style={{maxWidth: '35px', marginRight: 'auto', marginTop: '30px'}}> </div>
                    <LanguageSelector languages={this.props.languages}/>
			{UserAvatar(whoami())}
            <Button
            color="inherit"
            className={toolbarStyles.navbarBtn}
            onClick={() => {rest.oidcService.logout();}}>
          <FontAwesomeIcon icon={faSignOutAlt} style={{ fontSize: '1.75em' }} title={t`Sign out`} />
          </Button>
        </Toolbar>
      </AppBar>
      {this.buildDesktop()}
    </div>
  );
  }
}
